<template>
    <div class="menu">
        <el-menu
            :default-active="isActive"
            :default-openeds="isOpeneds"
            class="el-menu-vertical-demo"
            :unique-opened="true"
            router
            @select="handleSelect"
          >
            <div v-for="item in router" :key="item.id">
              <el-submenu :index="item.path" v-if="item.children">
                <template slot="title">
                  <i class="el-icon-s-platform"></i>
                  <span>{{ item.info.title }}</span>
                </template>
                <el-menu-item-group
                  v-for="items in item.children"
                  :key="items.path"
                >
                  <el-menu-item :index="items.path">
                    {{items.info.title}}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-menu-item :index="item.path" v-else>
                  <i :class="item.info.icon"></i>
                  <span>{{ item.info.title }}</span>
              </el-menu-item>
            </div>
        </el-menu>
    </div>
</template>
<script>
export default {
    data(){
        return{
           
        }
    },
    props:{
        isActive:{
            type:String,
            default:''
        },
        isOpeneds:{
            type:Array,
            default:()=>[]
        },
        router:{
            type:Array,
            default:()=>[]
        }
    },
    methods:{
        handleSelect(val){
            if(val == this.$route.path) return 
            this.$emit('changeIsAction',val)
        }
    }
}
</script>
<style scoped>

</style>